module.exports = __webpack_public_path__ + "img/document.266bf1f3.png";